// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"619":"648f0fc7","638":"fa808774","803":"02814e19","828":"b1d5e3cb","893":"6d77acc2"}[chunkId] + ".chunk.css";
};